import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function Guid() {
  const { theme } = useSelector((state) => state.theme);
  return (
    <div
      className={`max-w-[1280px] mx-auto px-4 py-8 ${theme === "dark" ? "text-white" : "text-black"
        } fontRoboto `}
    >
      <h2 className="text-3xl font-bold text-center mb-8 ">
        Installing the Tracker App
      </h2>

      <div className="grid md:grid-cols-1 gap-8">
        {/* macOS Section */}
        <div className="w-full flex items-center justify-center mb-4">
          <div
            className={` rounded-[30px] shadow p-6 pr-40 border ${theme === "dark"
                ? "bg-[#212529] border-[#555657]"
                : "bg-white border-[#D8D8D8]"
              }`}
            style={{ boxShadow: "0px 0px 30px 0px #00000026" }}
          >
            <h3 className="text-2xl font-semibold mb-4 text-red-600">
              Installing on macOS
            </h3>
            <ul className="list-disc list-inside space-y-2">
              <li>Visit the download link for the macOS version.</li>
              <li>
                Download either the Intel-based Mac or Apple Silicon (M1/M2)
                version.
              </li>
            </ul>
            <h4 className="mt-4 font-semibold">Install the App:</h4>
            <ul className="list-disc list-inside space-y-2">
              <li>Open the downloaded .dmg file.</li>
              <li>Drag the App icon into the Applications folder.</li>
            </ul>
            <h4 className="mt-4 font-semibold">Run the App:</h4>
            <ul className="list-disc list-inside space-y-2">
              <li>
                Open the Applications folder and double-click the tracker app.
              </li>
              <li>
                If you see a warning about an unidentified developer,
                right-click and click Open.
              </li>
            </ul>
            <h4 className="mt-4 font-semibold">
              Grant Permissions (if needed):
            </h4>
            <ul className="list-disc list-inside space-y-2">
              <li>Go to System Preferences → Security & Privacy → Privacy.</li>
              <li>
                Enable permissions for Screen Capture and Input Monitoring.
              </li>
            </ul>
            <h4 className="mt-4 font-semibold">
              Reset Permissions (if needed):
            </h4>
            <ul
              className={`list-disc list-inside text-sm mt-2 border p-2 ${theme === "dark"
                  ? "bg-[#212529] border-[#555657]"
                  : "bg-[#F2F4F7] border-[#9A9F9A]"
                }`}
            >
              <li>
                <code>tccutil reset Accessibility com.yourcompany.YourApp</code>
              </li>
              <li>
                <code>tccutil reset ScreenCapture com.yourcompany.YourApp</code>
              </li>
              <li>
                <code>
                  tccutil reset InputMonitoring com.yourcompany.YourApp
                </code>
              </li>
            </ul>
          </div>
          <div className="ml-[-150px]">
            <video
              className="h-[250px] w-full rounded-xl shadow-md"
              controls
              poster="https://via.placeholder.com/640x360.png?text=macOS+Tracker+Setup"
            >
              <source
                src="https://www.w3schools.com/html/mov_bbb.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        {/* Windows Section */}
        <div className="w-full flex items-center justify-center mb-4">
          {/* Dummy Video */}
          <div className="mr-[-150px]">
            <video
              className="w-full h-[250px] rounded-xl shadow-md z-10"
              controls
              poster="https://via.placeholder.com/640x360.png?text=Windows+Tracker+Setup"
            >
              <source
                src="https://www.w3schools.com/html/mov_bbb.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
          <div
            className={` rounded-[30px] shadow py-8 p-6 pl-40 border ${theme === "dark"
                ? "bg-[#212529] border-[#555657]"
                : "bg-white border-[#D8D8D8]"
              }`}
            style={{ boxShadow: "0px 0px 30px 0px #00000026" }}
          >
            <h3 className="text-2xl font-semibold mb-4 text-red-600">
              Installing on Windows
            </h3>
            <ul className="list-disc list-inside space-y-2">
              <li>Visit the download link for the Windows version.</li>
              <li>Download the .exe or .msi installer file.</li>
            </ul>
            <h4 className="mt-4 font-semibold">Install the App:</h4>
            <ul className="list-disc list-inside space-y-2">
              <li>Double-click the downloaded installer.</li>
              <li>Follow the on-screen instructions.</li>
            </ul>
            <h4 className="mt-4 font-semibold">Run the App:</h4>
            <ul className="list-disc list-inside space-y-2">
              <li>Launch the app from the Start Menu or desktop shortcut.</li>
            </ul>
          </div>
        </div>

        {/* linux Section */}
        <div className="w-full flex items-center justify-center mb-4">
          <div
            className={` rounded-[30px] shadow p-6 pr-40 border ${theme === "dark"
                ? "bg-[#212529] border-[#555657]"
                : "bg-white border-[#D8D8D8]"
              }`}
            style={{ boxShadow: "0px 0px 30px 0px #00000026" }}
          >
            <h3 className="text-2xl font-semibold mb-4 text-red-600">
              Installing on Linux
            </h3>
            <h4 className="mt-4 font-semibold">Download the App:</h4>
            <ul className="list-disc list-inside space-y-2">
              <li>Visit the download link for the Linux version.</li>
              <li>
                Download the .deb (Debian/Ubuntu), .rpm (Fedora/Red Hat), or
                precompiled binary.
              </li>
            </ul>
            <h4 className="mt-4 font-semibold">Install the App:</h4>
            <ul className="list-disc list-inside space-y-2">
              <li>For .deb files: sudo dpkg -i your-app-name.deb</li>
              <li>For .rpm files: sudo rpm -i your-app-name.rpm</li>
              <li>For binaries:</li>
              <li className="ml-4">
                Extract the archive: tar -xzf your-app-name.tar.gz
              </li>
              <li className="ml-4">
                Move the binary: sudo mv your-app-name /usr/local/bin/
              </li>
            </ul>
            <h4 className="mt-4 font-semibold">Run the App:</h4>
            <ul className="list-disc list-inside space-y-2">
              <li>Open the terminal and run the app with app name.</li>
              <li>Or run the app from the application menu.</li>
            </ul>
          </div>
          <div className="ml-[-150px]">
            <video
              className="h-[250px] w-full rounded-xl shadow-md"
              controls
              poster="https://via.placeholder.com/640x360.png?text=macOS+Tracker+Setup"
            >
              <source
                src="https://www.w3schools.com/html/mov_bbb.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <div
          className={` rounded-[30px] shadow p-6 w-full border ${theme === "dark"
              ? "bg-[#212529] border-[#555657]"
              : "bg-white border-[#D8D8D8]"
            }`}
          style={{ boxShadow: "0px 0px 30px 0px #00000026" }}
        >
          <h3 className="text-2xl font-semibold mb-4 text-red-600">
            TroubleShooting
          </h3>
          <ul className="text-lg">
            <li>
              {" "}
              <span className="font-bold">macOS:</span> Ensure necessary
              permissions are granted in System Preferences.
            </li>
            <li>
              <span className="font-bold">Windows:</span> Check for admin
              privileges and disk space.
            </li>
            <li>
              <span className="font-bold">Linux:</span> Install all required
              dependencies. Refer to documentation.
            </li>
          </ul>
        </div>
        <div className={` rounded-[30px] shadow p-6 pr-40 border ${theme === 'dark' ? 'bg-[#212529] border-[#555657]' : 'bg-white border-[#D8D8D8]'}`} style={{ boxShadow: '0px 0px 30px 0px #00000026' }}>
          <h3 className="text-2xl font-semibold mb-4 text-red-600">
            Support
          </h3>
          <p className="text-lg">If you need help, contact us at <span className="font-semibold">support@bugtrackin.com</span> or visit our website: <Link to='bugtrackin.com' className="text-blue-600 font-medium"> bugtrackin.com</Link></p>
        </div>
      </div>
    </div>
  );
}
